import styled from 'styled-components';
import { InfoButton } from '~/components/layout/Buttons'

export const ContainerProgressButton = styled(InfoButton)`
  position: relative;
  margin: -1rem 0 1rem 0;
`

export const ButtonProgressBar = styled.div`
  position: absolute;
  height: 100%;
  width: 0%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.2);
  transition: width .4s;
`

export const ButtomProgressText = styled.span`
  position: relative;
`
